import { AnalyticsProductComponent } from './analytics-product.component';

export default AnalyticsProductComponent;
